/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <SearchPharmacy {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { Section } from "@bw/bits"
import { SearchPharmacy as SearchPharmacyModule } from "@bw/modules"
import { useStaticQuery, graphql } from "gatsby"
import shuffle from "../../../utils/shuffle"

const SearchPharmacy = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  anchor,
}) => {
  const { allCollectionPharmacies } = useStaticQuery(graphql`
    query SearchPharmacyQuery {
      allCollectionPharmacies {
        nodes {
          id
          title
          slug
          street
          zipCode
          city
          state {
            value
          }
          latitude
          longitude
        }
      }
    }
  `)

  const shuffled = React.useMemo(() => {
    return shuffle(allCollectionPharmacies.nodes).map(p => ({
      ...p,
      state: p.state?.value,
    }))
  }, [allCollectionPharmacies.nodes])

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition: buttonPosition?.value,
        anchor,
      }}
    >
      <SearchPharmacyModule pharmacies={shuffled} />
    </Section>
  )
}

export { SearchPharmacy }
